<div class="c-password-modal" cdkTrapFocus cdkTrapFocusAutoCapture role="dialog" aria-modal="true" aria-labelledby="changePasswordModalTitle">
  <div class="c-password-modal__header">
    <div class="c-password-modal__title-group">
      <div class="c-password-modal__icon-badge">
        <mat-icon>lock_reset</mat-icon>
      </div>
      <div>
        <h2 id="changePasswordModalTitle">Alterar Senha</h2>
        <p class="c-password-modal__subtitle">Atualize suas credenciais com segurança</p>
      </div>
    </div>
    @if (!isForced) {
      <button type="button" (click)="onCancel()" class="c-password-modal__close-btn" tabindex="-1" title="Fechar" aria-label="Fechar">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="c-password-modal__body">

    <!-- Senha Atual -->
    <div class="c-form-group">
      <label class="c-form-label" for="changeCurrentPasswordInput">Senha Atual</label>
      <div class="c-input-box" [class.has-focus]="false">
        <input
          id="changeCurrentPasswordInput"
          name="currentPassword"
          [type]="hideCurrent ? 'password' : 'text'"
          formControlName="currentPassword"
          placeholder="Digite sua senha atual"
          class="c-native-input"
          autocomplete="current-password"
          />
        <button type="button" class="c-eye-btn" (click)="hideCurrent = !hideCurrent" tabindex="-1" [attr.aria-label]="hideCurrent ? 'Mostrar senha atual' : 'Ocultar senha atual'">
          <mat-icon>{{ hideCurrent ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </div>
    </div>

    <!-- Nova Senha -->
    <div class="c-form-group">
      <label class="c-form-label" for="changeNewPasswordInput">Nova Senha</label>
      <div class="c-input-box">
        <input
          id="changeNewPasswordInput"
          name="newPassword"
          [type]="hideNew ? 'password' : 'text'"
          formControlName="newPassword"
          placeholder="Crie uma senha forte"
          class="c-native-input"
          autocomplete="new-password"
          />
        <button type="button" class="c-eye-btn" (click)="hideNew = !hideNew" tabindex="-1" [attr.aria-label]="hideNew ? 'Mostrar nova senha' : 'Ocultar nova senha'">
          <mat-icon>{{ hideNew ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </div>
    </div>

    <!-- Confirmar Nova Senha -->
    <div class="c-form-group">
      <label class="c-form-label" for="changeConfirmPasswordInput">Confirmar Nova Senha</label>
      <div class="c-input-box">
        <input
          id="changeConfirmPasswordInput"
          name="confirmPassword"
          [type]="hideConfirm ? 'password' : 'text'"
          formControlName="confirmPassword"
          placeholder="Repita a nova senha"
          class="c-native-input"
          autocomplete="new-password"
          />
        <button type="button" class="c-eye-btn" (click)="hideConfirm = !hideConfirm" tabindex="-1" [attr.aria-label]="hideConfirm ? 'Mostrar confirmação' : 'Ocultar confirmação'">
          <mat-icon>{{ hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </div>
    </div>

    <!-- Checklist de Requisitos de Segurança em Tempo Real -->
    @if (newPasswordValue.length > 0) {
      <div class="c-password-rules">
        <p class="c-password-rules__title">Critérios de Segurança:</p>
        <div class="c-password-rules__item" [class.valid]="hasMinLength">
          <mat-icon class="rule-icon">{{ hasMinLength ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
          <span>Mínimo de 8 caracteres</span>
        </div>
        <div class="c-password-rules__item" [class.valid]="hasSpecialChar">
          <mat-icon class="rule-icon">{{ hasSpecialChar ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
          <span>Ao menos 1 caractere especial (!&#64;#$%^&*...)</span>
        </div>
        @if (confirmPasswordValue.length > 0) {
          <div class="c-password-rules__item" [class.valid]="passwordsMatch">
            <mat-icon class="rule-icon">{{ passwordsMatch ? 'check_circle' : 'cancel' }}</mat-icon>
            <span>As senhas coincidem</span>
          </div>
        }
      </div>
    }

    <!-- Footer com Botões -->
    <div class="c-password-modal__footer">
      @if (!isForced) {
        <button type="button" class="btn-modal-cancel" (click)="onCancel()" (mousedown)="$event.preventDefault()">
          Cancelar
        </button>
      }
      <button
        type="submit"
        class="btn-modal-submit"
        [disabled]="passwordForm.invalid || isLoading">
        @if (!isLoading) {
          <mat-icon>check</mat-icon>
        }
        <span>{{ isLoading ? 'Salvando…' : 'Salvar Alteração' }}</span>
      </button>
    </div>
  </form>
</div>
